import React            from 'react';
import TimelineActivity from '~/components/drawers/timeline/activity';

const TimelineActivityCandidateMoved = ({
  icon = 'briefcase',
  prefix = 'far',
  color = 'text-grey-dark',
  title = (obj) => {
    const { activity } = obj.props;
    const { job_title, location, name = 'Candidate' } = activity.parameters || {};

    return (
      `${name} was moved to ${job_title} Job${location ? ` in ${location}` : ''}`
    );
  },
  ...props
}) => <TimelineActivity {...props} icon={icon} prefix={prefix} color={color} title={title} />;

export default TimelineActivityCandidateMoved;
